// extracted by mini-css-extract-plugin
module.exports = {"fontStyle":"ConnectivityStatus_fontStyle__31kuQ"};